<script setup lang="ts">

import CustomModal from "@/components/CustomModal/CustomModal.vue";
import CustomButton from "@/components/Button/Button.vue";
import {useI18n} from "vue-i18n";
import {watch} from "vue";
import {CrewMember} from "@/models/CrewMember";

const props = defineProps<{
  showDeleteModal: boolean;
  member: CrewMember;
  listId: string;
}>();

defineEmits<{
  'on-close': [void]
  'on-delete-click': [CrewMember]
}>();

const { t } = useI18n();

// Body scroll lock if popup displayed
watch(() => props.showDeleteModal, (newValue) => {
  if (newValue) {
    document.documentElement.style.overflow = 'hidden';
  } else {
    document.documentElement.style.overflow = 'auto';
  }
});

</script>

<template>
  <CustomModal :show="showDeleteModal" @close="$emit('on-close')" classes="w-1/6" :mobile-fullscreen="false" :custom-index="9999" extra-classes="h-fit"
               drawerHeight="fit-content">
    <div class="sm:p-4 flex flex-col sm:max-w-sm sm:w-full container">
      <div class="cursor-pointer self-end hidden sm:block" type="default" @click="$emit('on-close')">
        <img src="@/assets/icons/svg/Close_16x16.svg" alt="Close" width="18"/>
      </div>
      <div class="sm:p-3.5 flex flex-col gap-8">
        <div class="responsive-title-6 font-bold">{{ t('memberDeleteModal.deleteMemberList', {member: member.name}) }}</div>
        <p>
          {{ t('memberDeleteModal.confirmationMessageList', {member: member.name}) }}
        </p>
        <div class="flex gap-4 justify-space-between">
          <CustomButton
              type="black"
              class="self-start"
              :outlined="false"
              :rounded="true"
              @click="$emit('on-delete-click',props.member)"
          >
            {{ t('memberDeleteModal.deleteButton') }}
          </CustomButton>
          
          <CustomButton
              :outlined="true"
              class="self-start hover:bg-black hover:text-white hover:border-black transition-all"
              :rounded="true"
              @click="$emit('on-close')">
            {{ t('memberDeleteModal.cancelButton') }}
          </CustomButton>
        </div>
      </div>
    </div>
  </CustomModal>
</template>
